import dayjs from 'dayjs';
import qs from 'query-string';
import { ofType } from 'redux-observable';
import { concat, defer, EMPTY, of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';

import { dayjsLocales } from '@/modules/common/constants/languages';
import { QUERY_LANGUAGE_KEY } from '@/modules/common/constants/queryParams';

import { deepSearchSetFilterByAction } from '../../../Search/redux/slices/deepSearch';
import { setAllowedChipTagTypes } from '../../helpers/chips';
import { getTabList } from '../../helpers/deepSearch';
import { isInternalType } from '../../helpers/embedCodeParams';
import logger from '../../helpers/logger';
import { fetchConfig } from '../../helpers/request';
import { setPlayerName } from '../../helpers/video';
import { configFetchStartAction, resetStoreAction, setLanguageAction, updateConfigAction } from '../slices/common';
import { getHashLocation, processHistoryObject } from '@/modules/common/helpers/history';

export default (action$) =>
  action$.pipe(
    ofType(configFetchStartAction.type),
    switchMap(() =>
      concat(
        of(resetStoreAction()),
        defer(() => fetchConfig()).pipe(
          mergeMap((config) => {
            dayjsLocales[config.language]().then(() => {
              dayjs.locale(config.language);
            });

            const actions = [of(setLanguageAction(config.language))];

            const { search } = getHashLocation();
            const parsedSearch = qs.parse(search);
            const queryLanguage = parsedSearch[QUERY_LANGUAGE_KEY];

            if (queryLanguage && !config.languages.find((lang$) => lang$.value === queryLanguage)) {
              delete parsedSearch[QUERY_LANGUAGE_KEY];

              const newURL = processHistoryObject({
                search: parsedSearch,
              });

              window.history.replaceState({}, '', `${window.location.pathname}${window.location.search}#${newURL}`);
            }

            logger.log('STORE config', config);
            if (config.status && !isInternalType) {
              config.channels.forEach(({ logo }) => {
                if (logo) {
                  const rel = 'preload';
                  const dataKey = `data-${rel}-href`;

                  if (!document.head.querySelector(`[${dataKey}="${logo}"]`)) {
                    const link = document.createElement('link');
                    link.setAttribute(dataKey, logo);
                    link.rel = rel;
                    link.href = logo;
                    link.as = 'image';

                    document.head.appendChild(link);
                  }
                }
              });
            }

            setAllowedChipTagTypes(config.tagTypes.slice());
            setPlayerName(config.player.name);

            if (config.deepSearch) {
              const [firstTabType] = getTabList(config.dsTags);

              actions.push(of(deepSearchSetFilterByAction(firstTabType)));
            }

            actions.push(of(updateConfigAction(config)));

            return concat(...actions);
          }),
          catchError((error) => {
            logger.error('Can`t request config', error);

            return EMPTY;
          }),
        ),
      ),
    ),
  );
